// stores/callStore.ts
import { defineStore } from "pinia";

interface CallState {
  connectionStatus: string;
  /**
   * The socket has dropped at least once since this was last cleared, so anything
   * built from realtime events may be missing whatever arrived during the gap —
   * Pusher does not replay. Screens that depend on being told about every change
   * (the paged inbox) watch this to offer a reload.
   */
  socketGapSinceReload: boolean;
  callStatus: string | null;
  callData: any | null;
}

const DISCONNECTED_STATES = ["disconnected", "failed", "unavailable"];

export const useStatusStore = defineStore("call", {
  state: (): CallState => ({
    connectionStatus: "Disconnected",
    socketGapSinceReload: false,
    callStatus: null,
    callData: null,
  }),
  actions: {
    setConnectionStatus(status: string) {
      // Callers are inconsistent: Pusher's `state_change` reports lowercase
      // ("connected"), while the explicit handlers pass "Connected". Normalise on the
      // way in — the only consumer compares capitalised, so without this the
      // indicator reads wrong whenever state_change happens to fire last.
      const normalized =
        status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

      if (DISCONNECTED_STATES.includes(status.toLowerCase())) {
        this.socketGapSinceReload = true;
      }

      this.connectionStatus = normalized;
    },
    clearSocketGap() {
      this.socketGapSinceReload = false;
    },
    setCallStatus(status: string, payload?: any) {
      this.callStatus = status;
      this.callData = payload || null;
    },
    resetCall() {
      this.callStatus = null;
      this.callData = null;
    },
  },
});
